import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Stack,
  Alert,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useAuth } from '../context/AuthContext';
import api from '../api/client';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const { login } = useAuth();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) {
      setError('Hasło musi mieć co najmniej 8 znaków.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Hasła nie są takie same.');
      return;
    }
    try {
      const account = await api.post('/api/auth/reset-password', { token, password });
      login(account);
      setSent(true);
    } catch (err) {
      setError(err.body?.error || err.message || 'Nie udało się zresetować hasła.');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: theme.tokens?.semantic?.surface?.canvas ?? '#F7F6F3',
        p: { xs: 2, sm: 3 },
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 440, borderRadius: `${theme.tokens?.primitive?.radius?.hero ?? 30}px` }}>
        <CardContent sx={{ p: { xs: 3, sm: 5 } }}>
          <Typography variant="h4" sx={{ mb: 1, fontWeight: 750, fontSize: { xs: '1.5rem', sm: '1.75rem' } }}>
            Nowe hasło
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Ustaw nowe hasło do konta.
          </Typography>
          {sent ? (
            <Alert severity="success">Hasło zmienione. Przekierowanie...</Alert>
          ) : (
            <form onSubmit={handleSubmit}>
              <Stack spacing={2.5}>
                {error && <Alert severity="error">{error}</Alert>}
                {!token && <Alert severity="error">Brak tokenu resetu hasła.</Alert>}
                <TextField
                  label="Nowe hasło"
                  type="password"
                  fullWidth
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <TextField
                  label="Powtórz hasło"
                  type="password"
                  fullWidth
                  required
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <Button type="submit" variant="contained" fullWidth size="large">
                  Zapisz hasło
                </Button>
              </Stack>
            </form>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}

export default ResetPassword;
